<div>
    {{ 'reactivatePopup.reasonText' | translate }}
    <div class="field">
        <label>{{ 'reactivatePopup.reason' | translate }}</label>
        <textarea pTextarea required [(ngModel)]="reason"></textarea>
    </div>
</div>
<div class="dialog-actions">
    <p-button variant="text" (click)="cancel()">{{ 'button.cancel' | translate | uppercase }}</p-button>
    <p-button (click)="confirm()">{{ 'button.confirm' | translate | uppercase }}</p-button>
</div>
